import { Trans } from 'react-i18next'
import styled, { css } from 'styled-components'

import { BuyPremiumIcon, premiumFontCss } from '@root/entities/premium/ui'
import { DomUtil } from '@root/shared'
import BG_ARROWS from '@root/shared/assets/banner-premium.inline.svg'

type Props = {
  onClick?: () => void
  mode?: PremiumBannerMode
}
type PremiumBannerMode = 'desktop' | 'mobile'

// @deprecated on mobile?
export const PremiumBanner = ({ onClick, mode = 'desktop' }: Props) => {
  return (
    <Root $mode={mode} onClick={onClick}>
      <UpperGlowing />
      <Title $mode={mode}>
        <Trans
          i18nKey="profile.statistics.buy_premium"
          components={[<span key={0} />, <strong key={1} />]}
        />
      </Title>
      <LowerGlowing />
      <BuyPremiumIcon
        product="subscription"
        size={53}
        css={css`
          position: absolute;
          right: 60px;
          top: calc(50% - 25px);
        `}
      />
    </Root>
  )
}

const ModeToPadding: Record<PremiumBannerMode, string> = {
  desktop: '24px 28px',
  mobile: '12px 16px',
}

const Root = styled.div<{ $mode: PremiumBannerMode }>`
  overflow: hidden;
  position: relative;
  cursor: pointer;
  box-shadow: inset 0 0 0 1px var(--subscriptionButtonA-3);
  flex-shrink: 0;

  border-radius: 12px;
  background: var(--appearance-1);

  padding: ${(x) => ModeToPadding[x.$mode]};

  background-image: ${DomUtil.cssUrl(BG_ARROWS)};
  background-size: cover;
  background-repeat: no-repeat;

  background-position: 100% 2px;
  background-size: 170px;
`
const ModeTo1TitleSize: Record<PremiumBannerMode, number> = {
  desktop: 18,
  mobile: 14,
}
const ModeTo2TitleSize: Record<PremiumBannerMode, number> = {
  desktop: 28,
  mobile: 22,
}
const ModeTo3TitleSize: Record<PremiumBannerMode, number> = {
  desktop: 20,
  mobile: 16,
}
const Title = styled.div<{ $mode: PremiumBannerMode }>`
  position: relative;
  color: var(--text-12);

  font-size: ${(x) => ModeTo3TitleSize[x.$mode]}px;
  font-style: normal;
  font-weight: 700;

  flex-shrink: 0;
  align-self: stretch;

  span {
    display: table;
    flex-shrink: 0;
    align-self: stretch;

    font-size: ${(x) => ModeTo1TitleSize[x.$mode]}px;
    font-style: normal;
    font-weight: 800;
    text-transform: uppercase;

    background: linear-gradient(
      93deg,
      var(--subscriptionGradientFromA-10) 1.35%,
      var(--subscriptionGradientTo-9) 29.71%,
      var(--subscriptionGradientToA-10) 79.71%
    );
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  strong {
    display: table;
    flex-shrink: 0;
    align-self: stretch;

    font-size: ${(x) => ModeTo2TitleSize[x.$mode]}px;
    font-style: normal;
    font-weight: 700;
    line-height: 115%;

    ${premiumFontCss}
  }
`

const UpperGlowing = styled.span`
  width: 300px;
  height: 100px;
  flex-shrink: 0;
  background-image: radial-gradient(
    160px 90px at 30% 10%,
    var(--subscriptionGlowA-6) 0%,
    transparent 100%
  );
  position: absolute;
  left: -50px;
  top: -40px;
  opacity: 0.45;
  filter: blur(48px);
`

const LowerGlowing = styled.span`
  background-image: radial-gradient(
    70% 160px at 190px 120%,
    var(--subscriptionGradientFromA-8) 0%,
    var(--subscriptionGradientToA-3) 100%
  );

  position: absolute;
  width: 100%;
  height: 300px;
  left: 0;
  bottom: 0;
  opacity: 0.6;
`
